import { Languages } from '@wajeez-web/core/utils';
import {
  CollectionComponentFormBuilder,
  InputFieldWithSelectorOptions,
} from './CollectionComponentFormBuilder';

interface CollectionComponentCreateFormProps {
  inputFieldsWithSelectorOptions: InputFieldWithSelectorOptions[] | undefined;
  onSubmit: () => void;
  onCancel?: () => void;
  collectionComponentTypeId?: number | undefined;
}

export const CollectionComponentCreateForm = ({
  inputFieldsWithSelectorOptions,
  onSubmit,
  onCancel,
  collectionComponentTypeId,
}: CollectionComponentCreateFormProps) => {
  return (
    <div className="w-full mx-auto">
      <CollectionComponentFormBuilder
        type="Create"
        dynamicFields={inputFieldsWithSelectorOptions}
        profiles={[
          {
            languageId: Languages.AR,
            fields: inputFieldsWithSelectorOptions,
          },
        ]}
        onSubmit={onSubmit}
        onCancel={onCancel}
        collectionComponentTypeId={collectionComponentTypeId}
      />
    </div>
  );
};
